import React from "react"
import { View } from "react-native"
import Animated, { BounceIn } from "react-native-reanimated"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { CAUTION, DANGER } from "./precallColors"
import { STATUS } from "../../../engine/precall/deviceCheckRules"

/**
 * La couleur des puces du guidage. Le vert y est plus clair que dans
 * `STEP_TONE` : il se pose sur du blanc, pas sur une pastille déjà teintée.
 */
export const DOT_COLOR = {
    [STATUS.OK]: theme.colors.success,
    [STATUS.WARN]: CAUTION,
    [STATUS.BAD]: DANGER,
    [STATUS.PENDING]: theme.colors.light,
}

/** Le fond et l'encre de la pastille d'une étape, selon son verdict. */
export const STEP_TONE = {
    [STATUS.OK]: { bg: theme.colors.successLight, fg: theme.colors.successDark },
    [STATUS.WARN]: { bg: theme.colors.warningLight, fg: CAUTION },
    [STATUS.BAD]: { bg: theme.colors.errorLight, fg: DANGER },
    [STATUS.PENDING]: { bg: theme.colors.lighter, fg: theme.colors.light },
}

/**
 * Une ligne de la checklist.
 *
 * Chaque étape garde **en permanence sa phrase d'état** — « On t'entend »,
 * « Connexion rapide » — et pas seulement quand c'est son tour : une étape
 * franchie qui se replie sur son seul nom fait perdre de vue ce qui a été
 * vérifié.
 */
const StepRow = ({ step, tone, muted, children }) => (
    // `flex-start`, et non `center` : dès que la phrase d'état passe sur deux
    // lignes, un alignement centré fait descendre l'icône au milieu du bloc et
    // décroche l'action de droite du titre auquel elle se rapporte. Accrochées
    // à la ligne de titre, les deux tiennent quand la ligne grandit.
    <View style={{ flexDirection: "row", alignItems: "flex-start" }}>
        {/* La clé change avec le verdict : la pastille rejoue son entrée. Ce
            petit sursaut est ce qui fait sentir qu'une vérification vient
            d'aboutir — et rien d'autre ne bouge. Le verdict ACQUIS, comme la
            couleur qu'il porte : sur le chemin court, la pastille tressaille
            quand le souvenir s'applique, au lieu d'attendre une mesure qui
            n'aura pas lieu. */}
        <Animated.View
            key={step.acquiredVerdict}
            entering={BounceIn.duration(420)}
            style={{
                width: 30,
                height: 30,
                borderRadius: 9,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: tone.bg,
            }}
        >
            <FontAwesome5 name={step.icon} size={13} color={tone.fg} />
        </Animated.View>

        <View style={{ flex: 1, marginLeft: 11, paddingTop: muted ? 3 : 1 }}>
            <TextM
                color={muted ? theme.colors.grey : theme.colors.black}
                fontSize={muted ? 13.5 : 15.5}
                fontWeight={"Bold"}
                style={{ letterSpacing: -0.1 }}
            >
                {step.label}
            </TextM>
            <TextM
                color={theme.colors.light}
                fontSize={12}
                style={{ marginTop: 2, lineHeight: 17 }}
                wrap
            >
                {step.detail}
            </TextM>
        </View>

        {/* Accrochés à la ligne de titre. */}
        {!!children && <View style={{ paddingTop: muted ? 4 : 3 }}>{children}</View>}
    </View>
)

export default StepRow
